class LogoListToggle extends HTMLElement {
  constructor() {
    super();
    this.itemsPerRow = parseInt(this.dataset.itemsPerRow) || 7;
    this.container = this.querySelector('.logo-list');
    this.items = this.container ? Array.from(this.container.querySelectorAll('.logo-item')) : [];
    this.button = null;
    this.isExpanded = false;
  }

  connectedCallback() {
    if (this.items.length > this.itemsPerRow) {
      this.createToggleButton();
      this.hideExtraItems();
    }
  }

  createToggleButton() {
    this.button = document.createElement('button');
    this.button.className = 'logo-list-toggle-btn';
    this.button.type = 'button';
    this.updateButtonText();
    this.button.addEventListener('click', () => this.toggle());
    this.appendChild(this.button);
  }

  hideExtraItems() {
    this.items.forEach((item, index) => {
      if (index >= this.itemsPerRow) {
        item.style.display = 'none';
      }
    });
  }

  showAllItems() {
    this.items.forEach((item) => {
      item.style.display = '';
    });
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
    
    if (this.isExpanded) {
      this.showAllItems();
    } else {
      this.hideExtraItems();
      // Scroll to the container smoothly
      this.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
    
    this.updateButtonText();
  }

  updateButtonText() {
    if (this.button) {
      this.button.textContent = this.isExpanded ? 'Show Less' : 'Show More';
      this.button.setAttribute('aria-expanded', this.isExpanded);
    }
  }
}

customElements.define('logo-list-toggle', LogoListToggle);
